import { render, staticRenderFns } from "./GroupCardNew.vue?vue&type=template&id=4ff595da&scoped=true"
import script from "./GroupCardNew.vue?vue&type=script&lang=ts"
export * from "./GroupCardNew.vue?vue&type=script&lang=ts"
import style0 from "./GroupCardNew.vue?vue&type=style&index=0&id=4ff595da&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff595da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff595da')) {
      api.createRecord('4ff595da', component.options)
    } else {
      api.reload('4ff595da', component.options)
    }
    module.hot.accept("./GroupCardNew.vue?vue&type=template&id=4ff595da&scoped=true", function () {
      api.rerender('4ff595da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/teams/GroupCardNew.vue"
export default component.exports